
import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import { PresetChartType } from '../chart-presets/const';
import type { IDoughnutChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

export class DoughnutChart extends BaseSubChart implements IDoughnutChart {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData): void {
        this.convertSubChartUiToSdkByType(SubChartType.DoughnutChart, uiData, sdkData, rawUiData);
    }
    public type = SubChartType.DoughnutChart;
    /**
     * 内径
     */
    public holeSize: number;
    /**
     * 第一片扇区角度
     */
    public firstSliceAngle: number;

    public getPresetChartType(): PresetChartType {
        return PresetChartType.DOUGHNUT;
    }
}

